module.exports = __webpack_public_path__ + "static/media/will.b552ffe0.png";